export default {
    name: 'emarketing',
    publicPath: process.env.VUE_APP_API_BASE,
    backendUrl: process.env.VUE_APP_BACKEND_BASE,
    expirationPeriod: process.env.VUE_APP_EXPIRATION_PERIOD,
    mercureHubUrl: process.env.VUE_APP_MERCURE_HUB_URL,

    uploadEmailListProgressStatus: process.env.VUE_APP_UPLOAD_EMAIL_LIST_STATUS_URL,
    uploadUnsubscriberProgressStatus: process.env.VUE_APP_UPLOAD_UNSUBSCRIBER_STATUS_URL,
    uploadSpamDomainProgressStatus: process.env.VUE_APP_UPLOAD_SPAM_DOMAIN_STATUS_URL,
    uploadSpamEmailProgressStatus: process.env.VUE_APP_UPLOAD_SPAM_EMAIL_STATUS_URL,
    uploadSpamMxProgressStatus: process.env.VUE_APP_UPLOAD_SPAM_MX_STATUS_URL,
    uploadSocksProgressStatus: process.env.VUE_APP_UPLOAD_SOCKS_STATUS_URL,
    uploadSmtpRelaysProgressStatus: process.env.VUE_APP_UPLOAD_SMTP_RELAYS_STATUS_URL,
    uploadPmtaRelaysProgressStatus: process.env.VUE_APP_UPLOAD_PMTA_RELAYS_STATUS_URL,
    uploadPmtaServersProgressStatus: process.env.VUE_APP_UPLOAD_PMTA_SERVERS_STATUS_URL,

    campaignProgressStatus: process.env.VUE_APP_CAMPAIGN_PROGRESS_STATUS,
    campaignStatisticsSent: process.env.VUE_APP_CAMPAIGN_STATISTICS_SENT,
    campaignStatisticsBounces: process.env.VUE_APP_CAMPAIGN_STATISTICS_BOUNCES,
    campaignStatisticsOpens: process.env.VUE_APP_CAMPAIGN_STATISTICS_OPENS,
    campaignStatisticsClicks: process.env.VUE_APP_CAMPAIGN_STATISTICS_CLICKS,
    campaignStatisticsUnsubscribers: process.env.VUE_APP_CAMPAIGN_STATISTICS_UNSUBSCRIBERS,
    campaignStatisticsProfit: process.env.VUE_APP_CAMPAIGN_STATISTICS_PROFIT,

    notifications: process.env.VUE_APP_NOTIFICATIONS
}
